import type { FC } from 'react';
import React from 'react';
import styles from './breadcrumbs.module.css';

// Models:
import type { IBreadCrumbs } from '../../../data/models/header/breadcrumb.model';

interface Props {
  breadcrumbs?: IBreadCrumbs[];
}

export const Breadcrumbs: FC<Props> = (props) => {
  const { breadcrumbs = [] } = props;

  return (
    <div className={styles.container}>
      <div className={styles.shadow} />
      <ol
        className={styles.list}
        itemScope
        itemType="https://schema.org/BreadcrumbList"
      >
        {breadcrumbs.map((crumb, index) => {
          const { text, link } = crumb;
          const isLast = index === breadcrumbs.length - 1;
          const anchorText = typeof text === 'string' ? text : '';
          return (
            <li
              className={styles.elem}
              key={text}
              itemProp="itemListElement"
              itemScope
              itemType="https://schema.org/ListItem"
            >
              {isLast ? (
                <span className={styles.lastChild} itemProp="name">
                  {anchorText}
                </span>
              ) : (
                <span className={styles.anchor}>
                  <a className={styles.anchor} itemProp="item" href={link}>
                    <span itemProp="name">{anchorText}</span>
                  </a>
                  ,
                </span>
              )}
              <meta itemProp="position" content={String(index)} />
            </li>
          );
        })}
      </ol>
    </div>
  );
};
